import React from "react";
import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const BotaoContato = ({ celular }) => (
  <Button
    title="Clique para conversar com este candidato pelo WhatsApp"
    href={`https://wa.me/55${celular
      .replace(" ", "")
      .replace("-", "")
      .replace("(", "")
      .replace(")", "")}`}
    target="_blank"
    color="secondary"
    startIcon={<WhatsAppIcon />}
  >
    {celular}
  </Button>
);

export default BotaoContato;
